// extracted by mini-css-extract-plugin
export default {"buttonCount":"sm2PML_g","_withBrackets":"TsYaNteG"};